import React from 'react';
import classNames from 'classnames';
import { Nullable } from 'types/shared';

interface IDetailTextProps {
    label: string;
    value?: Nullable<string | number>;
    valueClassName?: string;
    removeTopMargin?: boolean;
}

const DetailText = ({
    label,
    value,
    valueClassName,
    removeTopMargin,
}: IDetailTextProps) => {
    const standardValueClassName = value ? 'text-dark' : 'text-muted';
    return (
        <div
            data-testid="detail-text-wrapper"
            className={classNames('d-flex justify-content-between', { 'mt-1': !removeTopMargin })}
        >
            <div className="text-muted">{label}</div>
            <div className={valueClassName || standardValueClassName}>{value || '-'}</div>
        </div>
    );
};

export default DetailText;
